<template>
	<div class="announcement-boxes-container" v-if="announcements && announcements.length">
		<announcement-box
			v-for="announcement in announcements"
			:key="announcement.id"
			:announcement="announcement"/>
	</div>
</template>

<script>
	import AnnouncementBox from "./AnnouncementBox";

	export default {
		name: "AnnouncementBoxesContainer",
		components: {
			AnnouncementBox,
		},
		props: ['announcements'],
	}
</script>

<style scoped lang="scss">
	.announcement-boxes-container {
		display: flex;
		flex-direction: column;
		gap: 10px;

		.announcement-box {
			// stays tappable even when a parent sets pointer-events: none (native fixed overlay)
			pointer-events: auto;
		}
	}
</style>
